import { useEffect, useState } from "react";

const navLinks = [
  { id: "featured", label: "首屏推荐" },
  { id: "hk-classics", label: "港片精选" },
  { id: "action", label: "动作专区" },
  { id: "wuxia", label: "武侠片" },
  { id: "eras", label: "怀旧剧场" },
  { id: "browse", label: "片单筛选" },
  { id: "guide", label: "观影指南" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleJump = (id: string) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled || open
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8 h-16 md:h-[68px] flex items-center justify-between gap-6">
        <a
          href="#top"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
          className="flex items-center gap-2.5 shrink-0"
        >
          <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-movie-2-line text-lg" aria-hidden="true"></i>
          </span>
          <span
            className={`font-heading text-lg md:text-xl font-bold tracking-wide transition-colors ${
              scrolled || open ? "text-foreground-950" : "text-background-50"
            }`}
          >
            大师兄影视
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-1">
          {navLinks.map((link) => (
            <a
              key={link.id}
              href={`#${link.id}`}
              onClick={(e) => {
                e.preventDefault();
                handleJump(link.id);
              }}
              className={`px-3 py-2 text-sm rounded-md whitespace-nowrap transition-colors ${
                scrolled
                  ? "text-foreground-700 hover:text-primary-600 hover:bg-primary-50"
                  : "text-background-100 hover:text-background-50 hover:bg-white/15"
              }`}
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#browse"
            onClick={(e) => {
              e.preventDefault();
              handleJump("browse");
            }}
            className={`hidden md:flex items-center gap-2 px-4 py-2 text-sm rounded-md whitespace-nowrap transition-colors ${
              scrolled
                ? "bg-primary-500 text-background-50 hover:bg-primary-600"
                : "bg-background-50 text-foreground-950 hover:bg-background-100"
            }`}
          >
            <i className="ri-search-eye-line" aria-hidden="true"></i>
            查片单
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label="打开导航菜单"
            aria-expanded={open}
            className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md border transition-colors ${
              scrolled || open
                ? "border-background-300 text-foreground-900"
                : "border-white/40 text-background-50"
            }`}
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} aria-hidden="true"></i>
          </button>
        </div>
      </div>

      {open && (
        <nav className="lg:hidden border-t border-background-200 bg-background-50 px-4 py-3 grid grid-cols-2 gap-2">
          {navLinks.map((link) => (
            <a
              key={link.id}
              href={`#${link.id}`}
              onClick={(e) => {
                e.preventDefault();
                handleJump(link.id);
              }}
              className="px-3 py-2.5 text-sm rounded-md bg-background-100 text-foreground-800 hover:bg-primary-100 hover:text-primary-800 transition-colors"
            >
              {link.label}
            </a>
          ))}
        </nav>
      )}
    </header>
  );
}